import { useState } from 'react';
import { RichTextEditor } from '@mantine/rte';
import { dataPrivacyText } from '../../data/data-privacy-text';

function DataPrivacy() {
  const [value, onChange] = useState(dataPrivacyText);
  return <RichTextEditor value={value} onChange={onChange} readOnly />;
}
export default DataPrivacy;
